import { db } from ".";
import {
    getDocs,
    collection,
    query,
    where,
    getDoc,
    doc,
    updateDoc,
    setDoc,
    deleteDoc
} from "firebase/firestore";


export const getCapitulos = (capitulosId) => {
    return new Promise((resolve, reject) => {
        const collectionRef = capitulosId
            ? query(
                collection(db, "capitulos"),
                where("id", "==", capitulosId)
            )
            : collection(db, "capitulos");

        getDocs(collectionRef)
            .then(response => {
                const capitulos = response.docs.map(doc => {
                    return {
                        id: doc.id,
                        ...doc.data()
                    };
                });

                resolve(capitulos);
            })
            .catch(error => {
                reject(error);
            });
    });
};


export const getProducts = (categoryId) => {
    return new Promise((resolve, reject) => {
        const collectionRef = categoryId
            ? query(
                collection(db, "obras"),
                where("categoria", "==", categoryId)
            )
            : collection(db, "obras");

        getDocs(collectionRef)
            .then(response => {
                const products = response.docs.map(doc => {
                    return {
                        id: doc.id,
                        ...doc.data()
                    };
                });

                resolve(products);
            })
            .catch(error => {
                reject(error);
            });
    });
};


export const getProduct = (productId) => {
    return new Promise((resolve, reject) => {
        getDoc(doc(db, "obras", productId))
            .then(response => {
                const product = {
                    id: response.id,
                    ...response.data()
                };

                resolve(product);
            })
            .catch(error => {
                reject(error);
            });
    });
};


// ADMIN - actualizar una obra
export const updateProduct = (productId, data) => {
    const productRef = doc(db, "obras", productId);

    return updateDoc(productRef, data);
};


// ADMIN - actualizar un capítulo
export const updateCapitulo = (capituloId, data) => {
    const capituloRef = doc(db, "capitulos", capituloId);

    return updateDoc(capituloRef, data);
};

// ADMIN - crear una obra
export const createProduct = async (productId, data) => {

    const productRef = doc(db, "obras", productId);

    const existingProduct = await getDoc(productRef);

    if (existingProduct.exists()) {
        throw new Error("product-exists");
    }

    return setDoc(productRef, data);
};


// ADMIN - borrar una obra
export const deleteProduct = (productId) => {

    const productRef = doc(db, "obras", productId);

    return deleteDoc(productRef);

};

// ADMIN - crear un capítulo
export const createCapitulo = async (capituloId, data) => {

    const capituloRef = doc(db, "capitulos", capituloId);

    const existingCapitulo = await getDoc(capituloRef);

    if (existingCapitulo.exists()) {
        throw new Error("capitulo-exists");
    }

    return setDoc(capituloRef, data);
};


// ADMIN - borrar un capítulo
export const deleteCapitulo = (capituloId) => {

    const capituloRef = doc(db, "capitulos", capituloId);

    return deleteDoc(capituloRef);

};

// ADMINISTRADORES - obtener listado
export const getAdmins = async () => {

    const querySnapshot = await getDocs(
        collection(db, "admins")
    );

    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }));

};


// ADMINISTRADORES - agregar
export const createAdmin = async (email) => {

    const adminEmail = email
        .trim()
        .toLowerCase();

    const adminRef = doc(
        db,
        "admins",
        adminEmail
    );

    const existingAdmin = await getDoc(adminRef);

    if (existingAdmin.exists()) {
        throw new Error("admin-exists");
    }

    return setDoc(adminRef, {
        email: adminEmail
    });

};


// ADMINISTRADORES - eliminar
export const deleteAdmin = (email) => {

    const adminEmail = email
        .trim()
        .toLowerCase();

    const adminRef = doc(
        db,
        "admins",
        adminEmail
    );

    return deleteDoc(adminRef);

};